export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const RESET_AUTH_DATA = 'RESET_AUTH_DATA'
